export function isGqlType<T, TName extends string>(
  obj: T,
  typename: TName,
): obj is Extract<T, { __typename: TName }> {
  return (obj as any)?.__typename === typename
}

export function isGraphQLError<T>(obj: T): obj is Extract<T, { errorCode: string }> {
  return (obj as any)?.errorCode != null
}

export const isGraphqlError = isGraphQLError
export const isGraphqlType = isGqlType
